import { SSRMultipartLink } from '@apollo/client-integration-nextjs'

/**
 * SSR Multipart Link configuration for Apollo Client.
 * This link enables Server-Side Rendering (SSR) with deferred query support.
 *
 * @remarks
 * The SSRMultipartLink is used to handle multipart responses in Next.js SSR context,
 * specifically for Apollo Client's defer/stream functionality.
 *
 * @see {@link https://www.apollographql.com/docs/react/api/link/apollo-link-http}
 *
 * @property {boolean} stripDefer - When false, preserves defer directives in the query
 * @property {number} cutoffDelay - Time in milliseconds to wait for deferred responses
 */
export const makeBrowserSsrMultipartLink = () =>
  new SSRMultipartLink({
    stripDefer: false,
    cutoffDelay: 100,
  })
